import axios from 'axios';

class InstanceMysqlApis {
  constructor() {
    const host = process.env.REACT_APP_HOST_APIS;
    const port = process.env.REACT_APP_PORT_APIS;
    const baseURL = port ? `${host}:${port}/api` : `${host}/api`;

    this.instance = axios.create({ baseURL });
  }

  getInstance() {
    if (!this.instance) {
      throw new Error("Axios instance not initialized.");
    }
    return this.instance;
  }

  setToken(token) {
    const host = process.env.REACT_APP_HOST_APIS;
    const port = process.env.REACT_APP_PORT_APIS;
    const baseURL = port ? `${host}:${port}/api` : `${host}/api`;

    this.instance = axios.create({
      baseURL,
      headers: {
        Authorization: token ? `Bearer ${token}` : ''
      }
    });
  }
}

const singletonMysqlApis = new InstanceMysqlApis();
export default singletonMysqlApis;
